import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title: "Cybersecurity starts with you",
  header: "Cybersecurity starts with you",
  date: "2025-07-25",
  description:
    "Why technology alone isn’t enough – and how everyday habits across your team dramatically reduce the risk of a breach.",
  category: "security",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
